'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _Message = require('./Message');

var _Message2 = _interopRequireDefault(_Message);

var _ColoringRecord = require('./ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _TypicalResponseTime = require('../typical-response-time/records/TypicalResponseTime');

var _TypicalResponseTime2 = _interopRequireDefault(_TypicalResponseTime);

var _WidgetAvailabilityOptions = require('../availability/records/WidgetAvailabilityOptions');

var _WidgetAvailabilityOptions2 = _interopRequireDefault(_WidgetAvailabilityOptions);

var _widgetDataTypes = require('../widget-data/constants/widgetDataTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPE = '@type';

exports.default = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, TYPE, _widgetDataTypes.V1), _defineProperty(_Record, 'agentsRestrictedToMaxConcurrentChats', null), _defineProperty(_Record, 'botResponder', null), _defineProperty(_Record, 'coloring', (0, _ColoringRecord2.default)()), _defineProperty(_Record, 'customAwayMessage', null), _defineProperty(_Record, 'companyName', null), _defineProperty(_Record, 'gates', null), _defineProperty(_Record, 'hasVisitorEmail', false), _defineProperty(_Record, 'hasVisitorGivenConsentToCommunicate', false), _defineProperty(_Record, 'hasVisitorGivenConsentToProcess', false), _defineProperty(_Record, 'inOfficeHours', false), _defineProperty(_Record, 'meetingsLinkText', null), _defineProperty(_Record, 'meetingsLinkUrl', null), _defineProperty(_Record, 'message', (0, _Message2.default)()), _defineProperty(_Record, 'messagesPageUri', null), _defineProperty(_Record, 'nextOfficeHoursStartTime', 0), _defineProperty(_Record, 'sendFrom', null), _defineProperty(_Record, 'sessionId', null), _defineProperty(_Record, 'showingHsBranding', false), _defineProperty(_Record, 'systemOnline', null), _defineProperty(_Record, 'typicalResponseTime', (0, _TypicalResponseTime2.default)()), _defineProperty(_Record, 'usingOfficeHours', false), _defineProperty(_Record, 'availabilityOptions', new _WidgetAvailabilityOptions2.default()), _defineProperty(_Record, 'showPreviousConversations', true), _defineProperty(_Record, 'widgetLocation', _widgetDataTypes.RIGHT_ALIGNED), _Record), 'WidgetData');
module.exports = exports['default'];